import React, { Component } from 'react';
import ReactTable from 'react-table';
import { Button, UncontrolledCollapse } from 'reactstrap';
import moment from 'moment';
import Pagination from '../Pagination/Pagination';
import { MEMBERSMODALVIEWS, PAGINATION_DEFAULT_LIMIT, BLOCKED, ACTIVE, NOT_APPROVED, USER_ROLES } from '../../helpers/constants';
import { I18n } from '../../I18n/components/storesList';

import 'react-table/react-table.css';
import './storesList.css';

class StoresList extends Component {
	constructor(props) {
		super(props)
		this.state = {
			pointMembers: {}
		}
	}

	memberToggle = id => {
		const members = {...this.state.pointMembers};
		members[id] = members[id] ? !members[id] : true;
		this.setState({
			pointMembers: {...members}
		});
	};

	render() {
		const {companyUsers, stores, lang, operators} = this.props;
		let firstElementNumber = this.props.currentPage * PAGINATION_DEFAULT_LIMIT + 1;
		const tableData = stores.map((store, index) => {
            const operatorNames = operators.filter(operator => store.operatorIds.includes(operator.id))
                .map(operator => operator.name);

            let slicedOperatorNames =operatorNames
                .slice(0, 2)
                .join('\n');

            if (operatorNames.length > 2) {
                slicedOperatorNames += '...';
            }

            return {
				count_id: firstElementNumber++,
				id: store.id,
				name: store.name,
				users: {
					users: companyUsers.filter(user => store.userIds.includes(user.id)),
					id: store.id
				},
				city: store.cityGeonameId,
				wifiAccess: {
					wifi: store && store.attributes ? (
							store.attributes.find(attr => attr.attribute.label === 'wifi_access')
						) : (
							false
						),
					isOnline: store.isOnline
				},
				status: store.status,
				lastActivity: store.lastActivity ? moment(store.lastActivity).format('YYYY-MM-DD') : 'none',
				operators: slicedOperatorNames,
				actions: (
					<div className="text-center ">
						{/* <Button
						title="Сотрудники"
						className="storeslist-card__btn"
						onClick={() => {
							this.props.getMembers(store);
							// this.props.changeMemberListView(MEMBERSMODALVIEWS.REMOVE);
						}}
						color="primary"
						size="sm"
						round="true"
						icon="true"
					>
						<i className="fas fa-users"/>
					</Button> */}
						<Button
							title="edit"
							className="storeslist-card__btn"
							onClick={() => {
								let selectedStore = tableData.find(item => item.id === store.id);
								this.props.editStore(selectedStore);
							}}
							color="inverse"
							size="sm"
							round="true"
							icon="true"
						>
							<i className="fa fa-edit"/>
						</Button>
						<Button
							title="delete"
							onClick={() => {
								let selectedStore = tableData.find(item => item.id === store.id);
								this.props.deleteStore(selectedStore)
							}}
							className="ml-1 storeslist-card__btn"
							color="danger"
							size="sm"
							round="true"
							icon="true"
						>
							<i className="fa fa-times"/>
						</Button>
					</div>
				),
				storeData: store
			};
		});

		return (
			<div className="stores-table MyReactTableClass">
				<ReactTable
					className="MyReactTableClass"
					getProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								border: "none",
								padding: "5px"
							}
						};
					}}
					getTheadProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								boxShadow: "none",
								padding: "10px 0",
								fontWeight: "700"
							}
						};
					}}
					getTheadThProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								borderRight: "none"
							}
						};
					}}
					getTdProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								borderRight: "none",
								textAlign: "center"
							}
						};
					}}
					getTrProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								alignItems: "center"
							}
						};
					}}
					getNoDataProps={(state, rowInfo, column, instance) => {
						return {
							style: {
								top: "100%"
							}
						};
					}}
					columns={[
						{
							Header: "#",
							accessor: "count_id",
							sortable: false,
							filterable: false,
							style: {
								textAlign: "left",
								fontSize: "0.8rem",
								textTransform: "lowercase"
							},
							maxWidth: 40,

						},
						{
							Header: `${I18n[lang].traiderPoint}`,
							accessor: "name",
							sortable: true,
							filterable: false,
							minWidth: 150,
							style: {
								fontSize: "0.8rem",
								textAlign: "left"
							},
							Cell: row => (
								<div className="stores-table__img">
									{/*<img*/}
									{/*    src={row.value.img ? row.value.img : profilephoto}*/}
									{/*    alt="user"*/}
									{/*    className="rounded-circle"*/}
									{/*    width="60"*/}
									{/*/>*/}
									<span>{row.value}</span>
								</div>
							)
						},
						{
							Header: `${I18n[lang].member}`,
							accessor: "users",
							sortable: false,
							filterable: false,
							minWidth: 300,
							width: 200,
							style: {
								fontSize: "0.8rem",
								textAlign: "center",
								fontStyle: "bold"
							},
							Cell: row => row.value.users && row.value.users.length ? (
								<div>
									<button className="storeslist__togglebtn" id={`toggler_${row.value.id}`}
											onClick={() => this.memberToggle(row.value.id)}>
										{this.state.pointMembers[row.value.id] ? I18n[lang].hide: I18n[lang].show}
									</button>
									<UncontrolledCollapse toggler={`#toggler_${row.value.id}`}
														  isOpen={this.state.pointMembers[row.value.id] ?
															  this.state.pointMembers[row.value.id] : false}>
										{
											row.value.users.map(user =>
												<div className="storeslist__contacts" key={user.id}>
													<span className="storeslist__contactemail"> {user.email}</span>
												</div>
											)
										}
									</UncontrolledCollapse>
								</div>
							) : null
						},
						// {
						//     Header: `${I18n[lang].contacts}`,
						//     accessor: "users",
						//     sortable: false,
						//     filterable: false,
						//     minWidth: 100,
						//     style: {
						//         fontSize: "0.9rem",
						//         textAlign: "center"
						//     },
						//     Cell: row => (
						//         companyUsers.map(user => {
						//             if (row.value.users.includes(user.id)) {
						//                 return <div key={user.id}>{user.email}</div>
						//             }
						//             return ""
						//         })
						//     )
						// },
						{
							Header: `${I18n[lang].city}`,
							accessor: "city",
							sortable: false,
							filterable: false,
							style: {
								textAlign: "center",
								fontSize: "0.8rem",
							},
							minWidth: 50,
							Cell: row => {
								const city = this.props.cities.filter(city => city.geonameId === row.value)[0];
								return <span>{city ? city.name : 'none'}</span>
							}

						},
						{
							Header: `${I18n[lang].wifi}`,
							accessor: "wifiAccess",
							sortable: false,
							filterable: false,
							maxWidth: 50,
							style: {
								fontSize: "0.8rem",
								textTransform: "lowercase"
							},
							Cell: row => (
								<span>
									{/*{row.value.isOnline ? (*/}
									{/*	<i className="fa fa-exclamation" title="on-line" style={{color: '#f62d51'}}></i>*/}
									{/*) : null}*/}
									{/*{*/}
									{/*	row.value.wifi && row.value.wifi.value === 'true' ? (*/}
									{/*		<i className="stores-icon fa  fa-wifi"*/}
									{/*			style={{color: '#57d500'}}*/}
									{/*		/>*/}
									{/*	) : (*/}
									{/*		<i className="stores-icon fa  fa-wifi"*/}
									{/*			style={{color: '#e9ecef'}}*/}
									{/*		/>*/}
									{/*	)*/}
									{/*}*/}
									{row.value.isOnline ? (
										<i className="stores-icon fa  fa-wifi"
										   title="on-line"
										   style={{color: '#57d500'}}
										/>
									) : (
										<i className="stores-icon fa  fa-wifi"
										   title="on-line"
										   style={{color: '#e9ecef'}}
										/>
									)}

								</span>
							)
						},
						{
							Header: `${I18n[lang].status}`,
							accessor: "status",
							sortable: false,
							filterable: false,
							maxWidth: 100,
							style: {
								fontSize: "0.8rem",
								textTransform: "lowercase",
							},
							Cell: row => (
								<span style={{
									background: row.value === BLOCKED ? '#f62d51'
										: row.value === NOT_APPROVED ? '#8898aa'
											: row.value === ACTIVE ? '#57D500' : '#000000',
									padding: "3px 5px",
									borderRadius: "45px",
									color: "#ffffff"
								}}>
									{
										row.value === BLOCKED ? `${I18n[lang].statusBlocked}` :
											row.value === NOT_APPROVED ? `${I18n[lang].statusPending}` :
												row.value === ACTIVE ? `${I18n[lang].statusActive}` : `${I18n[lang].noStatus}`
									}
								</span>
							)
						},
						{
							Header: `${I18n[lang].lastActivity}`,
							accessor: "lastActivity",
							sortable: true,
							filterable: false,
							maxWidth: 100,
							style: {
								fontSize: "0.8rem",
								textTransform: "lowercase"
							}
						},
						{
							Header: `${I18n[lang].operators}`,
							accessor: "operators",
							sortable: false,
							filterable: false,
							maxWidth: 200,
							style: {
								fontSize: "0.8rem",
								whiteSpace: "pre-line"
							}
						},
						{
							Header: "",
							accessor: "actions",
							sortable: false,
							filterable: false,
							maxWidth: 150
						}
					]}
					manualSorting={true}
					onSortedChange={this.props.sortBy}
					defaultSorted={[{
						id: this.props.sortState.id,
						desc: this.props.sortState.desc,
					}]}
					sort={[{id: this.props.sortState.id, desc: this.props.sortState.desc}]}
					PaginationComponent={Pagination}
					nextText={">>"}
					previousText={"<<"}
					defaultPageSize={-1}
					pageSize={tableData.length}
					// minRows={0}
					defaultPageSize={-1}
					showPaginationBottom={this.props.totalPages > 1 ? true : false}
					className="-highlight"
					data={tableData}
					filterable
					manual
					onPageChange={this.props.setCurrentPage}
					page={this.props.currentPage}
					pages={this.props.totalPages}
				/>
			</div>
		)
	}
};

export default StoresList



// WEBPACK FOOTER //
// ./src/components/StoresList/StoresList.js